import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { FileUpload } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';
import { DATATABLE_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
import axios from '../../../axios-url';

class GuestsAndEmployeeUploads extends Component {
    state = {
        selectedItems: [],
        selectedFile: null,        // ADD THIS
        uploadedFiles: [],          // ADD THIS
        isUploading: false,        // ADD THIS
        globalFilter: ''           // ADD THIS
    }

    // ADD THESE MISSING METHODS
    onFileSelect = (e) => {
        this.setState({ selectedFile: e.files[0] });
    }

    onUpload = (e) => {
        this.toast.show({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded Successfully'
        });
        this.setState({
            uploadedFiles: e.files || [],
            isUploading: false
        });
    }

    // Uploads via the app's configured axios instance, same pattern used
    // by other working uploads (e.g. Policy.js) since PrimeReact's built-in
    // uploader posts to its `url` prop directly and bypasses the API baseURL.
    customUploader = (event) => {
        const file = event.files[0];
        const frmData = new FormData();
        frmData.append('file', file, file.name);

        this.setState({ isUploading: true });

        axios.post('/master/api/upload?FolderName=GuestsAndEmployeeUploads', frmData)
            .then(response => {
                this.onUpload({ files: [...this.state.uploadedFiles, response.data] });
                if (this.fileUpload) {
                    this.fileUpload.clear();
                }
            })
            .catch(() => {
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Upload Failed' });
                this.setState({ isUploading: false });
            });
    }

    handleSave = () => {
        if (this.state.selectedFile) {
            this.setState({ isUploading: true });
            if (this.fileUpload) {
                this.fileUpload.upload();
            }
        } else {
            this.toast.show({
                severity: 'warn',
                summary: 'No File Selected',
                detail: 'Please select a file to upload'
            });
        }
    }

    handleBack = () => {
        if (this.props.onBack) {
            this.props.onBack();
        } else {
            window.history.back();
        }
    }

    handleCancel = () => {
        this.setState({
            selectedFile: null,
            uploadedFiles: [],
            isUploading: false
        });
        if (this.fileUpload) {
            this.fileUpload.clear();
        }
        this.toast.show({
            severity: 'info',
            summary: 'Cancelled',
            detail: 'Upload cancelled'
        });
    }

    leftToolbarContent = () => {
        return (
            <div className="p-d-flex p-ai-center">
                <Button
                    label="Back"
                    icon="pi pi-arrow-left"
                    onClick={this.handleBack}
                    className="p-button-secondary p-mr-2"
                />
            </div>
        );
    }

    rightToolbarContent = () => {
        return (
            <div className="p-d-flex p-jc-end">
                <Button
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={this.handleCancel}
                    className="p-button-danger p-mr-2"
                />
                <Button
                    label="Save"
                    icon="pi pi-save"
                    onClick={this.handleSave}
                    className="p-button-success"
                    loading={this.state.isUploading}
                    disabled={!this.state.selectedFile}
                />
            </div>
        );
    }

    actionTemplate = (rowData) => {
        return <div className="actionCenter">
            {(this.getAccess !== undefined && this.getAccess.editAccess !== false) &&
                <Link to={"/user/edit/" + rowData.userId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }
            {(this.getAccess !== undefined && this.getAccess.viewAccess !== false) &&
                <Link to={"/user/view/" + rowData.userId}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }
        </div>;
    }

    delete = () => {
        if (this.state.selectedItems.length > 0) {
            const updatedValue = this.state.selectedItems.map(value => {
                return { DeleteID: value.userId };
            })
            this.props.dynamicDeleteProcess('user', updatedValue, 'GeUsers');
        }
        else {
            this.growl.show({ severity: 'error', summary: null, detail: 'Please select checkbox' });
        }
    }

    statusRender = (rowData) => {
        let status = <Button type="button" label="In Active" className="p-button-danger p-button-rounded" ></Button>
        if (rowData.isActive === true || rowData.isActive === null) {
            status = <Button type="button" label="Active" className="p-button-success p-button-rounded" ></Button>
        }
        return <div className="actionCenter">
            {status}
        </div>;
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        this.props.getMasterTableList('GeUsers');
    }

    render() {
        if (this.getAccess !== undefined && this.getAccess.viewAccess === false) {
            this.props.history.push('/dashboard');
        }

        const header = (
            <div style={{ 'textAlign': 'right' }}>
                <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search..." />
            </div>
        );

        let tableData = [];
        if (this.props.tableLists?.usersList !== undefined) {
            tableData = this.props.tableLists.usersList;
        }

        return (
            <div className="p-grid padding">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}

                <Toast ref={(el) => this.toast = el} />
                <Toast ref={(el) => this.growl = el} />

                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Guest / Employee</h1>

                        <div className="p-grid">
                            <div className="p-col-12">
                                {/* Toolbar with Back, Save, Cancel buttons */}
                                <Toolbar
                                    className="p-mb-4"
                                    left={this.leftToolbarContent}
                                    right={this.rightToolbarContent}
                                />

                                <div className="card">
                                    <h3>Guest / Employees Uploads</h3>

                                    <div className="p-grid p-ai-center p-mt-3">
                                        <div className="p-col-12">
                                            <label className="p-mb-2" style={{ fontWeight: 'bold' }}>
                                                File To Select:
                                            </label>
                                        </div>

                                        <div className="p-col-12">
                                            <FileUpload
                                                ref={(el) => this.fileUpload = el}
                                                name="file"
                                                customUpload
                                                uploadHandler={this.customUploader}
                                                accept=".csv,.xlsx,.xls"
                                                maxFileSize={1000000}
                                                chooseLabel="Choose File"
                                                uploadLabel="Upload"
                                                cancelLabel="Cancel"
                                                auto={false}
                                                onSelect={this.onFileSelect}
                                                onError={(e) => {
                                                    this.toast.show({ severity: 'error', summary: 'Error', detail: 'Upload Failed' });
                                                    this.setState({ isUploading: false });
                                                }}
                                                chooseOptions={{ icon: 'pi pi-folder-open' }}
                                                uploadOptions={{ icon: 'pi pi-upload' }}
                                                cancelOptions={{ icon: 'pi pi-times' }}
                                                emptyTemplate={
                                                    <div className="p-text-center p-m-5">
                                                        <i className="pi pi-cloud-upload" style={{ fontSize: '3em', color: '#90A4AE' }}></i>
                                                        <p className="p-m-2">Drag and drop files here to upload</p>
                                                        <p className="p-text-secondary">Supported formats: CSV, Excel (.xlsx, .xls)</p>
                                                    </div>
                                                }
                                            />
                                        </div>
                                    </div>

                                    {/* Show selected file name */}
                                    {this.state.selectedFile && (
                                        <div className="p-mt-3">
                                            <div className="p-mb-2">
                                                <i className="pi pi-file" style={{ marginRight: '8px' }}></i>
                                                <strong>Selected File:</strong> {this.state.selectedFile.name}
                                                <span className="p-ml-2 p-text-secondary">
                                                    ({(this.state.selectedFile.size / 1024).toFixed(2)} KB)
                                                </span>
                                            </div>
                                        </div>
                                    )}

                                    {/* Show uploaded files list */}
                                    {this.state.uploadedFiles.length > 0 && (
                                        <div className="p-mt-3">
                                            <div className="p-mb-2">
                                                <strong>Uploaded Files:</strong>
                                            </div>
                                            {this.state.uploadedFiles.map((file, index) => (
                                                <div key={index} className="p-mb-1">
                                                    <i className="pi pi-check-circle" style={{ color: 'green', marginRight: '8px' }}></i>
                                                    {file.name}
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    <div className="p-col-12" style={{ marginTop: '2em' }}>
                                        <DataTable
                                            value={tableData}
                                            selection={this.state.selectedItems}
                                            onSelectionChange={e => this.setState({ selectedItems: e.value })}
                                            globalFilter={this.state.globalFilter}
                                            header={header}
                                            {...DATATABLE_CONFIG}
                                        >
                                            <Column selectionMode="multiple" style={{ width: '3em' }} />
                                            <Column field="userid1" header="Employee ID" sortable={true} />
                                            <Column field="EmployeeName" header="Employee Name" />
                                            <Column field="Nationality" header="Nationality" />
                                            <Column field="Company" header="Company" />
                                            <Column field="Gender" header="Gender" />
                                            <Column field="isActive" header="STATUS" body={this.statusRender} sortable={true} />
                                            <Column field="PropertyOccupied" header="Property Occupied" />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dynamicDeleteProcess: (model, data, func) => dispatch(actions.dynamicDeleteProcess(model, data, func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestsAndEmployeeUploads);